<template>
  <div>
    <h1>soy un reparto</h1>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Id</th>
            <th class="text-left">Nombre</th>
            <th class="text-left">Estado</th>
            <th class="text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="reparto in repartos" :key="reparto.id">
            <td>{{ reparto.id }}</td>
            <td>{{ reparto.nombre }}</td>
            <td>{{ reparto.estado }}</td>
            <td>
              <v-btn color="warning" v-if="reparto.estado == 'Pendiente'" small @click="cerrar(reparto)">Cerrar</v-btn>
              <v-btn color="primary" v-if="reparto.estado == 'Pendiente'" small @click="anular(reparto)">Anular</v-btn>
            </td>
            <!-- <td><v-btn small color="primary" v-if="pago.estado=='Validado'">Anular</v-btn></td> -->
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <AgregarReparto @agregado="agregado" />
  </div>
</template>
<script>
import axios from "axios";
import AgregarReparto from "@/components/distribucion/AgregarReparto.vue";

export default {
  data() {
    return {
      repartos: [],
    };
  },
  mounted() {
    axios
      .get("/repartos")
      .then((response) => {
        console.log(response);
        this.repartos = response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    agregado(reparto) {
        this.repartos.push(reparto)
    },
    cerrar() {},
    anular() {}
  },
  components: {
    AgregarReparto,
  },
};
</script>